import { gql } from "@apollo/client";

export type GetVehicleReturnContractResponse = {
  organization: {
    Fleet: {
      ContractReturn: {
        baseContract: {
          agreementNumber: string | null;
          endDate: string | null;
        };
        authorizedReturnLocationIds: string[] | null;
      };
    } | null;
  } | null;
};

export const GET_VEHICLE_RETURN_CONTRACT = gql`
    query getVehicleReturnContract(
        $organizationId: ID!,
        $agreementNumber: String!,
        $numberPlate: String!
    ) {
        organization(id: $organizationId) {
            id
            Fleet {
                ContractReturn(agreementNumber: $agreementNumber, numberPlate: $numberPlate) {
                    baseContract {
                        agreementNumber
                        endDate
                    }
                    authorizedReturnLocationIds
                }
            }
        }
    }
`;
